export class LocalStorageKeys {
    public static readonly FeatureFlags = 'FeatureFlags';
    public static readonly Claims = 'Claims';
    public static readonly ARCaching = 'ARCaching';
}
